module.exports = __webpack_public_path__ + "img/figure-18.0e565c3c.png";